{
  "version": 1,
  "asset_id": "4d2ac3b4-de03-49ec-b547-33eee1e31599",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4d2ac3b4-de03-49ec-b547-33eee1e31599/support-group-480.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4d2ac3b4-de03-49ec-b547-33eee1e31599/support-group-480.webp",
  "original_filename": "support-group-480.webp",
  "size": 29514,
  "content_type": "image/webp",
  "created_at": "2026-10-04T23:43:32Z"
}
